"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.answerCampaignQuestionOptions = void 0;
var answerCampaignQuestionOptions = exports.answerCampaignQuestionOptions = {
  props: function props(_ref) {
    var mutate = _ref.mutate,
      store = _ref.ownProps.store;
    return {
      answerCampaignQuestionMutation: function answerCampaignQuestionMutation(variables) {
        return mutate({
          variables: variables
        });
      }
    };
  }
};
//# sourceMappingURL=mutation-options.js.map